"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispachShippingOfferDialogResultEvent = dispachShippingOfferDialogResultEvent;
exports.getShippingOfferDialogResultEventDispatcher = getShippingOfferDialogResultEventDispatcher;
var _shippingOfferDialogResult = require("@ori-events/shipping-offer-dialog-result");
var _constants = require("../constants");
var _log = require("./log");
/**
 * @param appName Application name / logger key.
 * @returns Function which triggers event to navigate to next step in legacy code without checking
 * the applied shipping offer again. No need to update the displayed delivery
 * step here, as we navigate away from it anyway.
 */
function getShippingOfferDialogResultEventDispatcher(appName) {
  return detail => dispachShippingOfferDialogResultEvent(detail, appName);
}
function dispachShippingOfferDialogResultEvent(detail, appName) {
  const logDebug = (0, _log.getDebugLogger)(appName ?? _constants.APP_NAME);
  const event = new CustomEvent(_shippingOfferDialogResult.Name, {
    detail
  });
  logDebug(`Triggering ${_shippingOfferDialogResult.Name} event:`, event);
  window.dispatchEvent(event);
}
//# sourceMappingURL=dispatchShippingOfferDialogResultEvent.js.map